import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import PackageGymDialog from "./PackageGymDialog";
import PackageHomeDialog from "./PackageHomeDialog";
import PackageOnlineDialog from "./PackageOnlineDialog";
import Slider from "react-slick";
import Shapes_Left from "../assets/products_shapes_left.png";
import Shapes_Right from "../assets/products_shapes_right.png";
import Product_Gym_Icon from "../assets/product_gym_icon.svg";
import Product_Home_Icon from "../assets/product_home_icon.svg";
import Product_Online_Icon from "../assets/product_online_icon.svg";
import Product_Adventure_Icon from "../assets/product_adventure_icon.svg";
import Product_Adventure_Image from '../assets/adventure/hero.jpg';

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF',
        },
        primary: {
            main: "#FF3600",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#0D0D0D",
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserrat",
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.1em',
                    padding: '6px 14px',
                    borderRadius: '0',
                },
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '30px 0 20px 0',

        [theme.breakpoints.up('md')]: {
            justifyContent: 'space-between',
        },
    },
    productsContent: {
        padding: '20px 28px',
        textAlign: 'center',
    },
    title: {
        padding: '0 0 10px 0',
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    productsCarousel: {
        position: 'relative',
        padding: '0 0 10px 0',

        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    productsCarouselProduct: {
        padding: '0',
        textAlign: 'center',
    },
    productsList: {
        display: 'none',
        minHeight: '484px',
        justifyContent: 'center',
        position: 'relative',
        textAlign: 'center',
        padding: '0 30px 0 30px',

        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    productCatalogue: {
        zIndex: '100',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flexWrap: 'wrap',
        width: '915px',

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    backgroundLeft: {
        zIndex: '99',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '191px',
        height: '484px',
        backgroundImage: 'url(' + Shapes_Left + ')',
        backgroundRepeat: 'no-repeat',

        [theme.breakpoints.up('md')]: {
            bottom: '0',
        },
    },
    backgroundRight: {
        zIndex: '99',
        position: 'absolute',
        bottom: '0',
        right: '0',
        width: '217px',
        height: '454px',
        backgroundImage: 'url(' + Shapes_Right + ')',
        backgroundRepeat: 'no-repeat',
    },
    product: {
        margin: '0 auto',
        width: '280px',

        [theme.breakpoints.up('md')]: {
            margin: '0 20px',
            width: '265px',
        },
    },
    productLarge: {
        margin: '0 auto',
        width: '875px',

        [theme.breakpoints.up('md')]: {
            margin: '0 20px',
        },
    },
    productLargeContent: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '25px',
        margin: '20px 0',
        padding: '40px',
        color: '#000',
        background: '#FFF',
    },
    productLargeLeft: {
    },
    productLargeRight: {
        padding: '0 0 0 40px',
        textAlign: 'left',
    },
    productLargeIcon: {
        padding: '0 20px 0 0',
    },
    productLargeFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',

        margin: '0 auto',
    },
    productLargeFooterLeft: {
        margin: 'auto 0 0 0',
    },
    productLargeFooterRight: {
        margin: 'auto 0 0 0',
        textAlign: 'right',
    },
    productLargePriceContent: {
        padding: '0',
    },
    productLargePhoto: {
        width: '308px',

        '& img': {
            width: '100%',
        }
    },
    productContent: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '25px',
        margin: '20px 0',
        padding: '40px 20px',
        color: '#000',
        background: '#FFF',
    },
    productIcon: {
        margin: '0 auto',
        padding: '0 0 10px 0',
    },
    productTitle: {
        padding: '0 0 20px 0',
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    productDescription: {
        padding: '0',
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',
    },
    productPhoto: {
        width: '100%',
        padding: '0 0 20px 0',

        '& img': {
            width: '100%',
        }
    },
    productFooter: {
        marginTop: 'auto',
    },
    productPriceContent: {
        padding: '15px 0',
    },
    productFrom: {
        padding: '0 0 10px 0',
        fontFamily: 'Montserrat',
        fontSize: '0.9em',
        lineHeight: '1em',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: '#6300FF',
    },
    productPrice: {
        display: 'flex',
        justifyContent: 'center',
        padding: '0',
        fontFamily: 'Bungee',
        fontSize: '1.9em',
        lineHeight: '1em',
        color: '#6300FF',
    },
    productCurrency: {
        lineHeight: '1.4em',
        padding: '0 4px 0 0',
    },
    productAmount: {
        fontSize: '1.6em',
        lineHeight: '1em',
    },
    contactbtn: {
        padding: '10px 0',
    },
 });

class ProductsPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openGymPackages: false,
            openHomePackages: false,
            openOnlinePackages: false
        }
    }

    render() {
        let self = this;
        const { classes } = this.props;

        const handleClickOpenGym = () => {
            self.setState({openGymPackages: true});
        };

        const handleClickOpenHome = () => {
            self.setState({openHomePackages: true});
        };

        const handleClickOpenOnline = () => {
            self.setState({openOnlinePackages: true});
        };

        const handleClose = () => {
            self.setState({openGymPackages: false});
            self.setState({openHomePackages: false});
            self.setState({openOnlinePackages: false});
        };

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false
        };

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.productsContent}>
                            <PackageGymDialog open={self.state.openGymPackages} onClose={handleClose} />
                            <PackageHomeDialog open={self.state.openHomePackages} onClose={handleClose} />
                            <PackageOnlineDialog open={self.state.openOnlinePackages} onClose={handleClose} />

                            <div className={classes.title}>Movement That Fits You</div>
                            <div className={classes.description}>Supporting both body and mind to reach your health goals - starting with your FREE trial!</div>
                        </div>

                        <div className={classes.productsCarousel}>
                            <Slider {...settings}>
                                <div>
                                    <div className={classes.productsCarouselProduct}>
                                        <div className={classes.product}>
                                            <div className={classes.productContent}>
                                                <div className={classes.productIcon}><img src={Product_Home_Icon} alt={"Home"} /></div>
                                                <div className={classes.productTitle}>Home Training</div>
                                                <div className={classes.productDescription}>In the comfort of your own home we come to you. Mix it up by getting outside and training in your local park - the focus is on having fun with your fitness.</div>
                                                <div className={classes.productFooter}>
                                                    <div className={classes.productPriceContent}>
                                                        <div className={classes.productFrom}>From</div>
                                                        <div className={classes.productPrice}>
                                                            <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>80</div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenHome}>Packages</Button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className={classes.productsCarouselProduct}>
                                        <div className={classes.product}>
                                            <div className={classes.productContent}>
                                                <div className={classes.productIcon}><img src={Product_Gym_Icon} alt={"Gym"} /></div>
                                                <div className={classes.productTitle}>Gym Training</div>
                                                <div className={classes.productDescription}>Want to get your fitness kick in a gym environment? Then this is for you!  Get personally trained at a gym in the Adelaide area - pick-up and drop-off available.</div>
                                                <div className={classes.productFooter}>
                                                    <div className={classes.productPriceContent}>
                                                        <div className={classes.productFrom}>From</div>
                                                        <div className={classes.productPrice}>
                                                            <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>90</div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenGym}>Packages</Button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className={classes.productsCarouselProduct}>
                                        <div className={classes.product}>
                                            <div className={classes.productContent}>
                                                <div className={classes.productIcon}><img src={Product_Online_Icon} alt={"Online"} /></div>
                                                <div className={classes.productTitle}>Online Training</div>
                                                <div className={classes.productDescription}>Too far away?  No problem. We are experienced at delivering online personal training, where we train with you from our studio gym.</div>
                                                <div className={classes.productFooter}>
                                                    <div className={classes.productPriceContent}>
                                                        <div className={classes.productFrom}>From</div>
                                                        <div className={classes.productPrice}>
                                                            <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>70</div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenOnline}>Packages</Button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className={classes.productsCarouselProduct}>
                                        <div className={classes.product}>
                                            <div className={classes.productContent}>
                                                <div className={classes.productIcon}><img src={Product_Adventure_Icon} alt={"Adventure"} /></div>
                                                <div className={classes.productTitle}>Full Day Adventure</div>
                                                {/*
                                                <div className={classes.productPhoto}><img src={Product_Adventure_Image} alt={"Onkaparinga"} /></div>
                                                */}
                                                <div className={classes.productDescription}>The ultimate nature experience - hiking through the Onkaparinga Gorge, swimming in a waterhole and a winery lunch.  Pickup and drop-off from Adelaide CBD.</div>
                                                <div className={classes.productFooter}>
                                                    <div className={classes.productPriceContent}>
                                                        <div className={classes.productFrom}>From</div>
                                                        <div className={classes.productPrice}>
                                                            <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>149</div>
                                                        </div>
                                                    </div>
                                                    <div className={classes.productbtn}><a href="https://gyg.me/A9eoTqpl" target="_blank" rel="noopener noreferrer"><Button variant="contained">Find Out More</Button></a></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                            <div className={classes.backgroundLeft}></div>
                            <div className={classes.backgroundRight}></div>
                        </div>

                        <div className={classes.productsList}>
                            <div className={classes.productCatalogue}>

                                <div className={classes.product}>
                                    <div className={classes.productContent}>
                                        <div className={classes.productIcon}><img src={Product_Gym_Icon} alt={"Gym"} /></div>
                                        <div className={classes.productTitle}>Gym Training</div>

                                        <div className={classes.productDescription}>Want to get your fitness kick in a gym environment? Then this is for you!  Get personally trained at a gym in the Adelaide area - pick-up and drop-off available.</div>
                                        <div className={classes.productFooter}>
                                            <div className={classes.productPriceContent}>
                                                <div className={classes.productFrom}>From</div>
                                                <div className={classes.productPrice}>
                                                    <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>90</div>
                                                </div>
                                            </div>
                                            <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenGym}>Packages</Button></div>
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.product}>
                                    <div className={classes.productContent}>
                                        <div className={classes.productIcon}><img src={Product_Home_Icon} alt={"Home"} /></div>
                                        <div className={classes.productTitle}>Home Training</div>
                                        <div className={classes.productDescription}>In the comfort of your own home we come to you. Mix it up by getting outside and training in your local park - the focus is on having fun with your fitness.</div>
                                        <div className={classes.productFooter}>
                                            <div className={classes.productPriceContent}>
                                                <div className={classes.productFrom}>From</div>
                                                <div className={classes.productPrice}>
                                                    <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>80</div>
                                                </div>
                                            </div>
                                            <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenHome}>Packages</Button></div>
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.product}>
                                    <div className={classes.productContent}>
                                        <div className={classes.productIcon}><img src={Product_Online_Icon} alt={"Online"} /></div>
                                        <div className={classes.productTitle}>Online Training</div>
                                        <div className={classes.productDescription}>Too far away? No problem. We are experienced at delivering online personal training, where we train with you from our studio gym.</div>
                                        <div className={classes.productFooter}>
                                            <div className={classes.productPriceContent}>
                                                <div className={classes.productFrom}>From</div>
                                                <div className={classes.productPrice}>
                                                    <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>70</div>
                                                </div>
                                            </div>
                                            <div className={classes.productbtn}><Button variant="contained" onClick={handleClickOpenOnline}>Packages</Button></div>
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.productLarge}>
                                    <div className={classes.productLargeContent}>

                                        <div className={classes.productLargeLeft}>
                                            <div className={classes.productLargePhoto}><img src={Product_Adventure_Image} alt={"Onkaparinga"} /></div>
                                        </div>

                                        <div className={classes.productLargeRight}>
                                            <div className={classes.productTitle}><span className={classes.productLargeIcon}><img src={Product_Adventure_Icon} alt={"Adventure"} /></span>Full Day Adventure</div>
                                            <div className={classes.productDescription}>The ultimate nature experience - hiking through the Onkaparinga Gorge, swimming in a waterhole and a winery lunch.  Pickup and drop-off from Adelaide CBD.</div>
                                            <div className={classes.productLargeFooter}>
                                                <div className={classes.productLargeFooterLeft}>
                                                    <div className={classes.productbtn}><a href="https://gyg.me/A9eoTqpl" target="_blank" rel="noopener noreferrer"><Button variant="contained">Find Out More</Button></a></div>
                                                </div>

                                                <div className={classes.productLargeFooterRight}>
                                                    <div className={classes.productLargePriceContent}>
                                                        <div className={classes.productFrom}>From</div>
                                                        <div className={classes.productPrice}>
                                                            <div className={classes.productCurrency}>$</div><div className={classes.productAmount}>149</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className={classes.backgroundLeft}></div>
                            <div className={classes.backgroundRight}></div>
                        </div>

                        <div className={classes.productsContent}>
                            <div className={classes.description}>Not sure where to start?</div>
                            <div className={classes.contactbtn}><a href="mailto:matt@dragoncommunitygym.com"><Button variant="contained">Get in touch</Button></a></div>
                        </div>

                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(ProductsPanel)